import React, { useState, useEffect } from "react";
import NumberInputDocTien2 from "components/GenericComponent/NumberInput/vDocTien2";
import NumberInput2 from "../../../components/GenericComponent/NumberInput/v2";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { NhanVayCombo } from "constants/nhanVayConst";
import { formatDayMonth } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import {
  bindTypePaidNhanVay,
  bindKieuLaiSuatNhanVay,
} from "../../../constants/choVayConst";
import { Controller, useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import { convertToNumber } from "utils/numberExtension";
import { formatNumber } from "utils/currencyFormat";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import NumberInput from "components/GenericComponent/NumberInput";

export const ThongTinNhanVay = ({
  ttNhanvay,
  update,
  currentForm,
  cauHinhNhanVay,
  cauHinhTinhLai,
  UpdateTypePaid,
  batHinhThucThanhToan,
  hinhThucThanhToan,
  setHinhThucThanhToan,
}) => {
  const { errors, register, control } = currentForm;
  const updateTextNumber = (field) => (e) => {
    if (field == "LaiSuat" && ttNhanvay.KieuLaiSuat == 3)
      ttNhanvay.PhanTram = e.value;
    if (field == "LaiSuat" && ttNhanvay.KieuLaiSuat == 2)
      ttNhanvay.LaiNgayTong = e.value;

    update({
      ...ttNhanvay,
      [field]: e.value,
    });

    //alert(ttNhanvay.Sotienvay + 'thuty');
  };

  const updateTextNumber1 = (field) => (evt) => {
    update({
      ...ttNhanvay,
      [field]: convertToNumber(evt.value),
    });
  };

  const updateTextValue = (field) => (e) => {
    update({
      ...ttNhanvay,
      [field]: e.target.value,
    });
  };
  const onChangeDate = (field) => (evt) => {
    update({
      ...ttNhanvay,
      [field]: formatDayMonth(evt),
    });
  };
  const updateDropdown = (field) => (e) => {
    update({
      ...ttNhanvay,
      [field]: e.target.value,
    });
  };

  const updateDropdown1 = (field) => (e) => {
    update({
      ...ttNhanvay,
      [field]: e.target.value,
    });
    UpdateTypePaid(e.target.value);
  };

  const init = {
    valueCheck: false,
  };

  const [valueTT, setValueTT] = useState(init);
  const onChangeStatus = (IsNgayTraGoc) => {
    setValueTT({
      ...valueTT,
      valueCheck: IsNgayTraGoc,
    });
    ttNhanvay.IsNgayTraGoc = IsNgayTraGoc;
  };

  return (
    <>
      <div
        id="headingCollapse194"
        className="card-header mt-1"
        data-toggle="collapse"
        href="#collapse194"
        aria-expanded="true"
        aria-controls="collapse194"
      >
        <a className="card-title lead info collapsed" href={() => false}>
          <h3>Thông tin hợp đồng</h3>
        </a>
      </div>
      <div
        id="collapse194"
        role="tabpanel"
        aria-labelledby="headingCollapse94"
        className="card-collapse collapse show"
      >
        <div className="card-content">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12 col-lg-12">
                <div className="form-group row">
                  <label className="col-md-2 label-control color7-bold">
                    Ngày vay <span className="canh-bao-red">*</span>
                  </label>
                  <div className="col-md-4">
                    <fieldset>
                      <div className="input-group">
                        <DateTimePicker
                          onChange={onChangeDate("NgayVay")}
                          value={convertDate(ttNhanvay.NgayVay)}
                          name="NgayVay"
                          customInputRef={register}
                          customInput={
                            <input name="NgayVay" ref={register}></input>
                          }
                        ></DateTimePicker>
                        {/* <div className="input-group-append">
                          <span className="input-group-text">
                            <i className="mdi mdi-calendar"></i>
                          </span>
                        </div> */}
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div className="form-group row">
                  <NumberInput2
                    labelClass="col-md-2 label-control color7-bold"
                    inputClass="form-control input-sm"
                    inputWrapClass="col-md-4"
                    wrapperClass="form-group row"
                    labelText="Tổng tiền vay"
                    starRed="*"
                    placeholder="10,000,000"
                    inputProps={{
                      name: "ttNhanvay.Sotienvay",
                      onChange: updateTextNumber1("Sotienvay"),
                      value: ttNhanvay.Sotienvay,
                      rules: {
                        required: "Hãy nhập số tiền vay",
                      },
                      control: control,
                    }}
                    error={errors.Sotienvay}
                  ></NumberInput2>
                </div>
                {/* <NumberInputDocTien2
                  labelClass="col-md-2 label-control"
                  inputClass="form-control input-sm"
                  inputWrapClass="col-md-4"
                  wrapperClass="form-group row"
                  labelText="Tổng tiền vay"
                  starRed="*"
                  placeholder="10,000,000"
                  inputProps={{
                    name: "ttNhanvay.Sotienvay",
                    onChange: updateTextNumber1("Sotienvay"),
                    value: formatNumber(ttNhanvay.Sotienvay),
                    rules: {
                      required: "Hãy nhập số tiền vay",
                    },
                    control: control,
                  }}
                  error={errors.Sotienvay}
                ></NumberInputDocTien2> */}

                <div className="form-group row">
                  <NumberInput2
                    labelClass="col-md-2 label-control color7-bold"
                    inputClass="form-control input-sm"
                    inputWrapClass="col-md-4"
                    labelText="Kỳ đóng lãi"
                    starRed="*"
                    placeholder="4"
                    inputProps={{
                      name: "CountTypePaid",
                      value: ttNhanvay.CountTypePaid,
                      onChange: updateTextNumber1("CountTypePaid"),
                      rules: {
                        required: "Hãy nhập kỳ đóng lãi",
                      },
                      control: control,
                    }}
                    error={errors.CountTypePaid}
                  ></NumberInput2>

                  <div className="col-md-2">
                    <select
                      name="TypePaid"
                      ref={register}
                      className="form-control input-sm "
                      onChange={updateDropdown1("TypePaid")}
                      value={ttNhanvay.TypePaid}
                      defaultValue={ttNhanvay.TypePaid}
                    >
                      {bindTypePaidNhanVay(cauHinhNhanVay, ttNhanvay.TypePaid)}
                    </select>
                    {/* <select
                      name="TypePaid"
                      ref={register}
                      onChange={updateDropdown("TypePaid")}
                      value={ttNhanvay.TypePaid}
                      defaultValue={ttNhanvay.TypePaid}
                      className="form-control input-sm"
                    >
                      {NhanVayCombo.TypePaidDropdown.map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                    </select> */}
                  </div>
                </div>

                <div className="form-group row">
                  <NumberInput2
                    labelClass="col-md-2 label-control color7-bold"
                    inputClass="form-control input-sm"
                    inputWrapClass="col-md-4"
                    labelText="Lãi suất"
                    starRed="*"
                    placeholder="4"
                    inputProps={{
                      name: "LaiSuat",
                      value:
                        ttNhanvay.KieuLaiSuat === 3
                          ? ttNhanvay.PhanTram
                          : ttNhanvay.KieuLaiSuat === 2
                            ? ttNhanvay.LaiNgayTong
                            : ttNhanvay.LaiSuat,
                      onChange: updateTextNumber("LaiSuat"),
                      rules: {
                        required: "Hãy nhập lãi suất",
                        //Đổi giá trị từ state (áp mặc định theo kỳ) thì NumberFormat đẩy object vào form nên required không bắt được ô trống
                        validate: (v) =>
                          (v && typeof v === "object" ? v.value : v) !== "" ||
                          "Hãy nhập lãi suất",
                      },
                      control: control,
                    }}
                    error={errors.LaiSuat}
                  ></NumberInput2>

                  {parseFloat(ttNhanvay.TypePaid) !== 3 && (
                    <div className="col-md-2 mt-mid">
                      <select
                        name="KieuLaiSuat"
                        ref={register}
                        className="form-control input-sm"
                        onChange={updateDropdown("KieuLaiSuat")}
                        value={ttNhanvay.KieuLaiSuat}
                        defaultValue={ttNhanvay.KieuLaiSuat}
                      >
                        {bindKieuLaiSuatNhanVay(
                          cauHinhNhanVay,
                          ttNhanvay.TypePaid,
                          ttNhanvay.KieuLaiSuat,
                        )}
                      </select>
                    </div>
                  )}
                  {/*  <div className="col-md-2"> <select
                      name="TypePaid"
                      ref={register}
                      className="form-control input-sm"
                      onChange={updateDropdown("KieuLaiSuat")}
                      value={ttNhanvay.KieuLaiSuat}
                      defaultValue={ttNhanvay.KieuLaiSuat}
                    >
                      {bindTypePaid(cauHinhTheoLoaiTaiSan)}
                    </select> */}
                  {/* <select
                      name="KieuLaiSuat"
                      ref={register}
                      onChange={updateDropdown("KieuLaiSuat")}
                      value={ttNhanvay.KieuLaiSuat}
                      defaultValue={ttNhanvay.KieuLaiSuat}
                      className="form-control input-sm"
                    >
                      {NhanVayCombo.KieuLaiSuatDropdown.map((item) => (
                        <option value={item.value}>{item.label}</option>
                      ))}
                    </select>  </div>*/}
                </div>

                <div className="form-group row">
                  <div className="col-md-2 label-control"></div>
                  <div className="col-md-4 ">
                    <div className="d-inline-block custom-control  mr-1">
                      <input
                        type="radio"
                        className=""
                        name="colorRadio"
                        id="radio1"
                        checked={ttNhanvay.IsNgayTraGoc === false}
                        onChange={(e) => onChangeStatus(false)}
                      />
                      <label className="" for="radio1" checked>
                        Số kỳ đóng lãi
                      </label>
                    </div>
                    <div className="d-inline-block custom-control  mr-1">
                      <input
                        type="radio"
                        className=""
                        name="colorRadio"
                        id="radio2"
                        checked={ttNhanvay.IsNgayTraGoc === true}
                        onChange={(e) => onChangeStatus(true)}
                      />
                      <label className="" for="radio2">
                        Ngày trả gốc
                      </label>
                    </div>
                  </div>
                </div>

                {ttNhanvay.IsNgayTraGoc === true ? (
                  <div className="form-group row">
                    <label className="col-md-2 label-control color7-bold">
                      Ngày trả <span className="canh-bao-red">*</span>
                    </label>
                    <div className="col-md-4">
                      <fieldset>
                        <div className="input-group">
                          <DateTimePicker
                            onChange={onChangeDate("NgayTra")}
                            value={convertDate(ttNhanvay.NgayTra)}
                            name="NgayTra"
                            customInputRef={register}
                            customInput={
                              <input name="NgayTra" ref={register}></input>
                            }
                          ></DateTimePicker>
                          {/* <div className="input-group-append">
                            <span className="input-group-text">
                              <i className="mdi mdi-calendar"></i>
                            </span>
                          </div> */}
                        </div>
                      </fieldset>
                    </div>
                  </div>
                ) : (
                  <div className="form-group row">
                    <NumberInput2
                      labelClass="col-md-2 label-control color7-bold"
                      inputClass="form-control input-sm"
                      inputWrapClass="col-md-4"
                      labelText="Số kỳ đóng lãi"
                      starRed="*"
                      placeholder="4"
                      inputProps={{
                        name: "SoLanTra",
                        value: ttNhanvay.SoLanTra,
                        onChange: updateTextNumber("SoLanTra"),
                        rules: {
                          required: "Hãy nhập số kỳ đóng lãi",
                        },
                        control: control,
                      }}
                      error={errors.SoLanTra}
                    ></NumberInput2>
                  </div>
                )}

                {cauHinhNhanVay.AllBeforeAfter && (
                  <div className="form-group row">
                    <label className="col-md-2 label-control color7-bold">
                      Kiểu thu lãi <span className="canh-bao-red">*</span>
                    </label>
                    <div className="col-md-4">
                      <select
                        name="BeforeAfter"
                        ref={register}
                        onChange={updateDropdown("BeforeAfter")}
                        value={ttNhanvay.BeforeAfter}
                        defaultValue={ttNhanvay.BeforeAfter}
                        className="form-control input-sm"
                      >
                        <option selected="selected" value="1">
                          Sau{" "}
                        </option>

                        <option value="2">Trước</option>
                      </select>
                    </div>
                  </div>
                )}

                {batHinhThucThanhToan && (
                  <div className="form-group row">
                    <label className="col-md-2 label-control color7-bold">
                      Hình thức thanh toán
                    </label>
                    <div className="col-md-4">
                      <select
                        value={hinhThucThanhToan}
                        onChange={(e) => setHinhThucThanhToan(e.target.value)}
                        className="form-control input-sm"
                      >
                        <option value="0">Tiền mặt</option>
                        <option value="1">Chuyển khoản</option>
                      </select>
                    </div>
                  </div>
                )}

                <div className="form-group row">
                  <label
                    className="col-md-2 label-control color7-bold"
                    for="userinput1"
                  >
                    Ghi chú
                  </label>
                  <div className="col-md-10">
                    <textarea
                      rows="1"
                      className="textarea-customer input-sm"
                      name="Note"
                      placeholder=""
                      value={ttNhanvay.Note}
                      onChange={updateTextValue("Note")}
                      ref={register}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
